import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from "axios";
import { format } from "date-fns";
import Actions from "./actions";
import { errorDuck } from "../error";
import * as UTIL from "../../util";
import { apiUtil } from "../../util";
import { ordersData, missingCreditData, pegModuleData, missingCreditDataOld } from './mockResponses';
var Creators = Actions.Creators;
var fetchAddress = Creators.fetchAddress;
var receiveAddress = Creators.receiveAddress;
var getAddress = Creators.getAddress;
var postAddress = Creators.postAddress;
var deleteAddress = Creators.deleteAddress;
var requestGetOrders = Creators.requestGetOrders;
var getOrders = Creators.getOrders;
var requestGuestOrder = Creators.requestGuestOrder;
var responseGuestOrder = Creators.responseGuestOrder;
var returnOrder = Creators.returnOrder;
var responseReturnOrder = Creators.responseReturnOrder;
var toReturn = Creators.toReturn;
var setShowReplacement = Creators.setShowReplacement;
var responseReturnOrderErr = Creators.responseReturnOrderErr;
var errorGuestOrder = Creators.errorGuestOrder;
var responseReOrder = Creators.responseReOrder;
var loginSuccess = Creators.loginSuccess;
var storeLoginSuccess = Creators.storeLoginSuccess;
var receiveAccountDetails = Creators.receiveAccountDetails;
var setHasSavedCart = Creators.setHasSavedCart;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;
var getAddressUrl = UTIL.apiUtil.generateUrl("marketing", "address");
var getAddressUrlForceVersion = UTIL.apiUtil.generateUrlForceVersion("marketing", "address", "v2");
var getAccountUrl = UTIL.apiUtil.generateUrl("marketing", "account");
var getAccountUrlForceVersion = UTIL.apiUtil.generateUrlForceVersion("marketing", "account", "v2");

var constructError = function constructError(err) {
  var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cb8502";

  try {
    return {
      response: {
        data: {
          results: {
            code: code,
            message: err.Errors[0]
          }
        }
      }
    };
  } catch (_unused) {
    return {
      response: {
        data: {
          results: {
            code: code,
            message: undefined
          }
        }
      }
    };
  }
};

function fetchAccount(state, token) {
  return function (dispatch) {
    var _state$account, _state$account$aadRes, _state$loyalty, _state$loyalty$accoun, _state$account2, _state$account2$aadRe, _state$account2$aadRe2, _state$account2$aadRe3, _state$account3, _state$account3$aadRe, _state$account3$aadRe2, _state$account3$aadRe3, _state$cbLocation, _state$cbLocation$loc, _cart$cart;

    var routeURL = UTIL.apiUtil.API.postAccount;
    var token = (_state$account = state.account) === null || _state$account === void 0 ? void 0 : (_state$account$aadRes = _state$account.aadResponse) === null || _state$account$aadRes === void 0 ? void 0 : _state$account$aadRes.jwtIdToken;
    var loyaltyId = (_state$loyalty = state.loyalty) === null || _state$loyalty === void 0 ? void 0 : (_state$loyalty$accoun = _state$loyalty.account) === null || _state$loyalty$accoun === void 0 ? void 0 : _state$loyalty$accoun.ExternalCustomerId;
    var loyaltyEmail = ((_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : (_state$account2$aadRe = _state$account2.aadResponse) === null || _state$account2$aadRe === void 0 ? void 0 : (_state$account2$aadRe2 = _state$account2$aadRe.account) === null || _state$account2$aadRe2 === void 0 ? void 0 : (_state$account2$aadRe3 = _state$account2$aadRe2.idToken) === null || _state$account2$aadRe3 === void 0 ? void 0 : _state$account2$aadRe3.email) || ((_state$account3 = state.account) === null || _state$account3 === void 0 ? void 0 : (_state$account3$aadRe = _state$account3.aadResponse) === null || _state$account3$aadRe === void 0 ? void 0 : (_state$account3$aadRe2 = _state$account3$aadRe.account) === null || _state$account3$aadRe2 === void 0 ? void 0 : (_state$account3$aadRe3 = _state$account3$aadRe2.idToken) === null || _state$account3$aadRe3 === void 0 ? void 0 : _state$account3$aadRe3.signInName);
    var storeNumber = (_state$cbLocation = state.cbLocation) === null || _state$cbLocation === void 0 ? void 0 : (_state$cbLocation$loc = _state$cbLocation.location) === null || _state$cbLocation$loc === void 0 ? void 0 : _state$cbLocation$loc.StoreNumber;
    var cart = state.cart;
    var hasCurrentCart = cart.cart && ((_cart$cart = cart.cart) === null || _cart$cart === void 0 ? void 0 : _cart$cart.length) > 0;
    return UTIL.apiUtil.fetchPost(routeURL, {
      loyaltyId: loyaltyId,
      loyaltyEmail: loyaltyEmail,
      storeNumber: storeNumber
    }, token).then(function (res) {
      if (res && res.ExistingCartInfo.CartId && res.ExistingCartInfo.StoreNumber && !hasCurrentCart) {
        dispatch(setHasSavedCart({
          hasSavedCart: true,
          savedCartLocation: res.ExistingCartInfo.StoreNumber
        }));
      } //SaveRecentItem


      if (res.success == true) {
        dispatch(receiveAccountDetails({
          registerLogin: true
        }));
      }
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
} //fetch store account


function fetchStoreAccount(state, token) {
  return function (dispatch) {
    var routeURL = UTIL.apiUtil.API.postStoreAccount;
    return axios.post(routeURL, "", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer ".concat(token)
      }
    }).then(function (res) {
      var data = {
        isLoggedIn: true,
        token: token
      };
      dispatch(storeLoginSuccess(data));
    }).catch(function (err) {
      console.log(err);

      if (err.response.status === 401) {
        var data = {
          isLoggedIn: false,
          token: ""
        };
        dispatch(storeLoginSuccess(data));
      }

      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function fetchGetAddress(state) {
  return function (dispatch) {
    var _state$account4, _state$account4$aadRe, _state$account5, _state$account5$aadRe, _state$account5$aadRe2, _state$account6, _state$account6$aadRe, _state$account6$aadRe2, _state$account6$aadRe3;

    var token = (_state$account4 = state.account) === null || _state$account4 === void 0 ? void 0 : (_state$account4$aadRe = _state$account4.aadResponse) === null || _state$account4$aadRe === void 0 ? void 0 : _state$account4$aadRe.jwtIdToken;
    var id = (_state$account5 = state.account) === null || _state$account5 === void 0 ? void 0 : (_state$account5$aadRe = _state$account5.aadResponse) === null || _state$account5$aadRe === void 0 ? void 0 : (_state$account5$aadRe2 = _state$account5$aadRe.account) === null || _state$account5$aadRe2 === void 0 ? void 0 : _state$account5$aadRe2.accountIdentifier;
    var subject = (_state$account6 = state.account) === null || _state$account6 === void 0 ? void 0 : (_state$account6$aadRe = _state$account6.aadResponse) === null || _state$account6$aadRe === void 0 ? void 0 : (_state$account6$aadRe2 = _state$account6$aadRe.account) === null || _state$account6$aadRe2 === void 0 ? void 0 : (_state$account6$aadRe3 = _state$account6$aadRe2.idTokenClaims) === null || _state$account6$aadRe3 === void 0 ? void 0 : _state$account6$aadRe3.sub;
    var url = "".concat(getAddressUrlForceVersion, "?account-key=").concat(id);

    if (typeof token !== "undefined") {
      dispatch(fetchAddress());
      var defualtHeaders = UTIL.apiUtil.setHeaders();

      var headers = _objectSpread(_objectSpread({}, defualtHeaders), {}, {
        "Content-Type": "application/json",
        Authorization: "Bearer ".concat(token)
      });

      return axios({
        method: "get",
        headers: headers,
        url: url
      }).then(function (json) {
        console.log("Operation returned addresses: ", json);
        return dispatch(getAddress(json));
      }).catch(function (err) {
        dispatch(receiveError(UTIL.buildError(err)));
      });
    } else {// TODO: define if we need to capture this error in a log
    }
  };
}

function replaceAddress(address, addresses) {
  var index = addresses.findIndex(function (item) {
    return item.addressId === address.addressId;
  });
  var updateAddress = addresses[index];
  Object.keys(updateAddress).forEach(function (key) {
    return updateAddress[key] = address[key] || updateAddress[key];
  });
  addresses.splice(index, 1, updateAddress);
  return addresses;
}

function removeAddress(address, addresses) {
  return addresses.filter(function (item) {
    return item.addressId !== address.addressId;
  });
}

function fetchPostAddress(state, address, addresses) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _state$account7, _state$account7$aadRe, _state$account8, _state$account8$aadRe, _state$account8$aadRe2;

      var token, id, loyaltyStorage, url, _loyaltyStorage$accou, _loyaltyStorage$accou2, defualtHeaders, headers, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = (_state$account7 = state.account) === null || _state$account7 === void 0 ? void 0 : (_state$account7$aadRe = _state$account7.aadResponse) === null || _state$account7$aadRe === void 0 ? void 0 : _state$account7$aadRe.jwtIdToken;
              id = (_state$account8 = state.account) === null || _state$account8 === void 0 ? void 0 : (_state$account8$aadRe = _state$account8.aadResponse) === null || _state$account8$aadRe === void 0 ? void 0 : (_state$account8$aadRe2 = _state$account8$aadRe.account) === null || _state$account8$aadRe2 === void 0 ? void 0 : _state$account8$aadRe2.accountIdentifier;
              loyaltyStorage = UTIL.getLoyaltyStorage();
              url = "".concat(getAddressUrl);

              if (!(typeof token !== "undefined")) {
                _context.next = 10;
                break;
              }

              dispatch(postAddress());
              defualtHeaders = UTIL.apiUtil.setHeaders();
              headers = _objectSpread(_objectSpread({}, defualtHeaders), {}, {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(token)
              });
              data = {
                addresses: [_objectSpread(_objectSpread({}, address), {}, {
                  addressId: address.addressId ? address.addressId : "",
                  aadb2cOID: id,
                  loyaltyCustomerID: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.ExternalCustomerId) || '',
                  emailAddress: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.Email) || ''
                })]
              };
              return _context.abrupt("return", axios({
                method: "post",
                headers: headers,
                data: data,
                url: url
              }).then(function (json) {
                var data = {};
                var savedAddresses = [];

                if (typeof address.addressId !== "undefined") {
                  savedAddresses = replaceAddress(address, addresses);
                } else {
                  var _json$data$results, _json$data$results$ad;

                  address.addressId = (_json$data$results = json.data.results) === null || _json$data$results === void 0 ? void 0 : (_json$data$results$ad = _json$data$results.addresses[0]) === null || _json$data$results$ad === void 0 ? void 0 : _json$data$results$ad.addressId;
                  addresses.push(address);
                  savedAddresses = addresses;
                }

                data = {
                  data: {
                    addresses: savedAddresses
                  }
                };
                return dispatch(getAddress(data));
              }).catch(function (err) {
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function fetchPutAddress(state, address, addresses) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var _state$account9, _state$account9$aadRe, _state$account10, _state$account10$aadR, _state$account10$aadR2;

      var token, id, loyaltyStorage, url, _loyaltyStorage$accou3, _loyaltyStorage$accou4, defualtHeaders, headers, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              token = (_state$account9 = state.account) === null || _state$account9 === void 0 ? void 0 : (_state$account9$aadRe = _state$account9.aadResponse) === null || _state$account9$aadRe === void 0 ? void 0 : _state$account9$aadRe.jwtIdToken;
              id = (_state$account10 = state.account) === null || _state$account10 === void 0 ? void 0 : (_state$account10$aadR = _state$account10.aadResponse) === null || _state$account10$aadR === void 0 ? void 0 : (_state$account10$aadR2 = _state$account10$aadR.account) === null || _state$account10$aadR2 === void 0 ? void 0 : _state$account10$aadR2.accountIdentifier;
              loyaltyStorage = UTIL.getLoyaltyStorage();
              url = "".concat(getAddressUrlForceVersion);

              if (!(typeof token !== "undefined")) {
                _context2.next = 10;
                break;
              }

              dispatch(postAddress());
              defualtHeaders = UTIL.apiUtil.setHeaders();
              headers = _objectSpread(_objectSpread({}, defualtHeaders), {}, {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(token)
              });
              data = {
                addresses: [_objectSpread(_objectSpread({}, address), {}, {
                  addressId: address.addressId ? address.addressId : "",
                  aadb2cOID: id,
                  loyaltyCustomerID: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou3 = loyaltyStorage.account) === null || _loyaltyStorage$accou3 === void 0 ? void 0 : _loyaltyStorage$accou3.ExternalCustomerId) || '',
                  emailAddress: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou4 = loyaltyStorage.account) === null || _loyaltyStorage$accou4 === void 0 ? void 0 : _loyaltyStorage$accou4.Email) || ''
                })]
              };
              return _context2.abrupt("return", axios({
                method: "put",
                headers: headers,
                data: data,
                url: url
              }).then(function (json) {
                var data = {};
                var savedAddresses = [];

                if (typeof address.addressId !== "undefined") {
                  savedAddresses = replaceAddress(address, addresses);
                } else {
                  var _json$data$results2, _json$data$results2$a;

                  address.addressId = (_json$data$results2 = json.data.results) === null || _json$data$results2 === void 0 ? void 0 : (_json$data$results2$a = _json$data$results2.addresses[0]) === null || _json$data$results2$a === void 0 ? void 0 : _json$data$results2$a.addressId;
                  addresses.push(address);
                  savedAddresses = addresses;
                }

                data = {
                  data: {
                    addresses: savedAddresses
                  }
                };
                return dispatch(getAddress(data));
              }).catch(function (err) {
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function fetchDeleteAddress(state, address, addresses) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var _state$account11, _state$account11$aadR, _state$account12, _state$account12$aadR, _state$account12$aadR2;

      var token, id, url, defualtHeaders, headers, data, message;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              token = (_state$account11 = state.account) === null || _state$account11 === void 0 ? void 0 : (_state$account11$aadR = _state$account11.aadResponse) === null || _state$account11$aadR === void 0 ? void 0 : _state$account11$aadR.jwtIdToken;
              id = (_state$account12 = state.account) === null || _state$account12 === void 0 ? void 0 : (_state$account12$aadR = _state$account12.aadResponse) === null || _state$account12$aadR === void 0 ? void 0 : (_state$account12$aadR2 = _state$account12$aadR.account) === null || _state$account12$aadR2 === void 0 ? void 0 : _state$account12$aadR2.accountIdentifier;
              url = "".concat(getAddressUrl);

              if (!(typeof token !== "undefined")) {
                _context3.next = 14;
                break;
              }

              dispatch(postAddress());
              defualtHeaders = UTIL.apiUtil.setHeaders();
              headers = _objectSpread(_objectSpread({}, defualtHeaders), {}, {
                // 'Ocp-Apim-Subscription-Key': environment.apiSubscription,
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(token)
              });

              if (!address.addressId) {
                _context3.next = 12;
                break;
              }

              data = {
                addresses: [{
                  addressId: address.addressId,
                  aadb2cOID: id
                }]
              };
              return _context3.abrupt("return", axios({
                method: "delete",
                headers: headers,
                data: data,
                url: url
              }).then(function (json) {
                var data = json;
                var savedAddresses = removeAddress(address, addresses);
                data = {
                  data: {
                    addresses: savedAddresses
                  }
                };
                return dispatch(getAddress(data));
              }).catch(function (err) {
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 12:
              message = UTIL.buildInternalError("cb8501");
              return _context3.abrupt("return", dispatch(receiveError(UTIL.buildError(message))));

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function fetchAccountOrders(state) {
  return function (dispatch) {
    var _state$account13, _state$account13$aadR;

    dispatch(setShowReplacement(false));
    dispatch(requestGetOrders());
    var token = (_state$account13 = state.account) === null || _state$account13 === void 0 ? void 0 : (_state$account13$aadR = _state$account13.aadResponse) === null || _state$account13$aadR === void 0 ? void 0 : _state$account13$aadR.jwtIdToken;
    var today = new Date();
    var tomorrow = format(today.setDate(today.getDate() + 1), "MMddyyyy") + "T23:59:59";
    var url = "".concat(apiUtil.API.getAccountOrders, "?endDate=").concat(tomorrow); // storybook mock

    if (window.location.href.indexOf("localhost:9009") > -1) {
      var result = {
        data: {
          orders: ordersData,
          fields: {
            MissingCredit: [{
              fields: missingCreditDataOld
            }, {
              fields: missingCreditData
            }],
            PegModule: [{
              fields: pegModuleData
            }]
          }
        }
      };
      return Promise.resolve(result || []);
    }

    return UTIL.apiUtil.fetchGet(url, token).then(function (json) {
      return dispatch(getOrders(json));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function upsertAccountSfmc(state, accountInfo) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var _state$account14, _state$account14$aadR, _state$account15, _state$account15$aadR, _state$account15$aadR2;

      var token, id, url, defaultHeaders, headers, data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              token = (_state$account14 = state.account) === null || _state$account14 === void 0 ? void 0 : (_state$account14$aadR = _state$account14.aadResponse) === null || _state$account14$aadR === void 0 ? void 0 : _state$account14$aadR.jwtIdToken;
              id = (_state$account15 = state.account) === null || _state$account15 === void 0 ? void 0 : (_state$account15$aadR = _state$account15.aadResponse) === null || _state$account15$aadR === void 0 ? void 0 : (_state$account15$aadR2 = _state$account15$aadR.account) === null || _state$account15$aadR2 === void 0 ? void 0 : _state$account15$aadR2.accountIdentifier;
              url = "".concat(getAccountUrl);

              if (!(typeof token !== "undefined")) {
                _context4.next = 10;
                break;
              }

              defaultHeaders = UTIL.apiUtil.setHeaders();
              headers = _objectSpread(_objectSpread({}, defaultHeaders), {}, {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(token)
              });
              data = {
                aadb2cOID: id,
                firstName: accountInfo.firstName,
                lastName: accountInfo.lastName,
                emailAddress: accountInfo.email,
                zipCode: null,
                mobilePhone: accountInfo.mobilePhone,
                promotionId: "ds-registered-guest",
                emailMarketingOptIn: true
              };

              if (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.loyaltyCustomerID) {
                Object.assign(data, {
                  loyaltyCustomerID: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.loyaltyCustomerID
                });
              }

              if (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.loyaltyAccountStatus) {
                Object.assign(data, {
                  loyaltyAccountStatus: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.loyaltyAccountStatus
                });
              }

              return _context4.abrupt("return", axios({
                method: "post",
                headers: headers,
                data: data,
                url: url
              }).catch(function (err) {
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function upsertAccountSfmcPut(state, accountInfo) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var _state$account16, _state$account16$aadR, _state$account17, _state$account17$aadR, _state$account17$aadR2;

      var token, id, url, defaultHeaders, headers, data;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              token = (_state$account16 = state.account) === null || _state$account16 === void 0 ? void 0 : (_state$account16$aadR = _state$account16.aadResponse) === null || _state$account16$aadR === void 0 ? void 0 : _state$account16$aadR.jwtIdToken;
              id = (_state$account17 = state.account) === null || _state$account17 === void 0 ? void 0 : (_state$account17$aadR = _state$account17.aadResponse) === null || _state$account17$aadR === void 0 ? void 0 : (_state$account17$aadR2 = _state$account17$aadR.account) === null || _state$account17$aadR2 === void 0 ? void 0 : _state$account17$aadR2.accountIdentifier;
              url = "".concat(getAccountUrlForceVersion);

              if (!(typeof token !== "undefined")) {
                _context5.next = 10;
                break;
              }

              defaultHeaders = UTIL.apiUtil.setHeaders();
              headers = _objectSpread(_objectSpread({}, defaultHeaders), {}, {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(token)
              });
              data = {
                aadb2cOID: id,
                firstName: accountInfo.firstName,
                lastName: accountInfo.lastName,
                emailAddress: accountInfo.email,
                zipCode: null,
                mobilePhone: accountInfo.mobilePhone,
                promotionId: "ds-registered-guest",
                emailMarketingOptIn: true
              };

              if (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.loyaltyCustomerID) {
                Object.assign(data, {
                  loyaltyCustomerID: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.loyaltyCustomerID
                });
              }

              if (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.loyaltyAccountStatus) {
                Object.assign(data, {
                  loyaltyAccountStatus: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.loyaltyAccountStatus
                });
              }

              return _context5.abrupt("return", axios({
                method: "put",
                headers: headers,
                data: data,
                url: url
              }).catch(function (err) {
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
}

var guestOrderCheck = function guestOrderCheck(data) {
  return function (dispatch) {
    dispatch(requestGuestOrder());
    dispatch(setShowReplacement(false));
    return UTIL.apiUtil.fetchPost(UTIL.apiUtil.API.commerce.guestOrderCheck, data).then(function (json) {
      if (json.message) {
        dispatch(errorGuestOrder());
        return dispatch(receiveError(UTIL.buildError(constructError({
          Errors: [json.message]
        }, "cb8503"))));
      } else {
        dispatch(responseGuestOrder({
          orders: [json]
        }));
        return json;
      }
    }).catch(function (err) {
      dispatch(errorGuestOrder());
      var message = UTIL.buildInternalError("cb8502");
      return dispatch(receiveError(UTIL.buildError(message)));
    });
  };
};

var postReturnOrder = function postReturnOrder(data) {
  return function (dispatch) {
    dispatch(returnOrder());
    return UTIL.apiUtil.fetchPost(UTIL.apiUtil.API.commerce.updateGuestOrderStatus, data).then(function (json) {
      dispatch(responseReturnOrder(Array.isArray(json) ? json : [json]));
      return json;
    }).catch(function (err) {
      dispatch(responseReturnOrderErr());
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
};

var postAccount = function postAccount(token) {
  return function (dispatch, getState) {
    return dispatch(fetchAccount(getState(), token));
  };
}; //store portal changes


var postStoreAccount = function postStoreAccount(token) {
  return function (dispatch, getState) {
    return dispatch(fetchStoreAccount(getState(), token));
  };
};

var getAccountAddress = function getAccountAddress() {
  return function (dispatch, getState) {
    return dispatch(fetchGetAddress(getState()));
  };
};

var postAccountAddress = function postAccountAddress(address, addresses) {
  return function (dispatch, getState) {
    return dispatch(fetchPostAddress(getState(), address, addresses));
  };
};

var putAccountAddress = function putAccountAddress(address, addresses) {
  return function (dispatch, getState) {
    return dispatch(fetchPutAddress(getState(), address, addresses));
  };
};

var deleteAccountAddress = function deleteAccountAddress(address, addresses) {
  return function (dispatch, getState) {
    return dispatch(fetchDeleteAddress(getState(), address, addresses));
  };
};

var getAccountOrders = function getAccountOrders(address, addresses) {
  return function (dispatch, getState) {
    return dispatch(fetchAccountOrders(getState()));
  };
};

function reOrderItems(orderId) {
  return function (dispatch, getState) {
    var _state$account18, _state$account18$aadR;

    var state = getState();
    var token = (_state$account18 = state.account) === null || _state$account18 === void 0 ? void 0 : (_state$account18$aadR = _state$account18.aadResponse) === null || _state$account18$aadR === void 0 ? void 0 : _state$account18$aadR.jwtIdToken;
    var url = "".concat(apiUtil.API.reOrder);
    var data = {
      OrderId: orderId
    };
    return UTIL.apiUtil.fetchPost(url, data, token).then(function (json) {
      dispatch(responseReOrder(true));
      return json;
    }).catch(function (err) {
      dispatch(responseReOrder(false));
      return dispatch(receiveError(UTIL.buildError(constructError(err, "cb8503"))));
    });
  };
}

function addLineFromOrder(orderId, lineId) {
  return function (dispatch, getState) {
    var _state$account19, _state$account19$aadR;

    var state = getState();
    var token = (_state$account19 = state.account) === null || _state$account19 === void 0 ? void 0 : (_state$account19$aadR = _state$account19.aadResponse) === null || _state$account19$aadR === void 0 ? void 0 : _state$account19$aadR.jwtIdToken;
    var url = "".concat(apiUtil.API.addLineFromOrder);
    var data = {
      OrderId: orderId,
      LineId: lineId
    };
    return UTIL.apiUtil.fetchPost(url, data, token).then(function (json) {
      dispatch(responseReOrder(true));
      return json;
    }).catch(function (err) {
      dispatch(responseReOrder(false));
      return dispatch(receiveError(UTIL.buildError(constructError(err, "cb8503"))));
    });
  };
}

var postUpsertAccountSfmc = function postUpsertAccountSfmc(accountInfo) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", dispatch(upsertAccountSfmc(getState(), accountInfo)));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6, _x7) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var putUpsertAccountSfmc = function putUpsertAccountSfmc(accountInfo) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", dispatch(upsertAccountSfmcPut(getState(), accountInfo)));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x8, _x9) {
      return _ref7.apply(this, arguments);
    };
  }();
};

export default {
  postAccount: postAccount,
  postStoreAccount: postStoreAccount,
  loginSuccess: loginSuccess,
  storeLoginSuccess: storeLoginSuccess,
  getAccountAddress: getAccountAddress,
  receiveAddress: receiveAddress,
  postAccountAddress: postAccountAddress,
  putAccountAddress: putAccountAddress,
  deleteAccountAddress: deleteAccountAddress,
  getAccountOrders: getAccountOrders,
  guestOrderCheck: guestOrderCheck,
  responseGuestOrder: responseGuestOrder,
  toReturn: toReturn,
  postReturnOrder: postReturnOrder,
  setShowReplacement: setShowReplacement,
  errorGuestOrder: errorGuestOrder,
  reOrderItems: reOrderItems,
  addLineFromOrder: addLineFromOrder,
  responseReOrder: responseReOrder,
  postUpsertAccountSfmc: postUpsertAccountSfmc,
  putUpsertAccountSfmc: putUpsertAccountSfmc,
  setHasSavedCart: setHasSavedCart
};